import React from 'react';
import { connect } from 'react-redux';

import GoalsList from './goals/List';
import ProjectsList from './projects/List';
import Render from '../../common/Render';
import { requestDataIfNeeded } from './duck';

class Screen extends React.Component {
  componentDidMount() {
    this.props.requestUserEventsDataIfNeeded();
  }

  renderAfterLoading = () => {
    const { userEvents } = this.props;

    return (
      <React.Fragment>
        {/* Last Updates on Projects Section */}
        <div className="u-margin-bottom-huge">
          <ProjectsList userEvents={userEvents} />
        </div>

        {/* Last Updates on Goals Section */}
        <div className="u-margin-bottom-huge">
          <GoalsList userEvents={userEvents} />
        </div>

        {/* Personal Message Section */}
        {/* <div className="u-margin-top-huge">
          <h3>Personal message (up to 420 characters)</h3>
          <div className="c-box c-box-primary u-margin-bottom-huge">
            <div className="c-box-primary__box u-display-flex u-justify-content-between u-align-items-center">
              <div className="c-box-primary__text">
                <div className="u-text-italic">
                  <p>
                    “Nam porttitor blandit accumsan. Ut vel dictum sem, a
                    pretium dui. In malesuada enim in dolor euismod, id commodo
                    mi consectetur. Curabitur at vestibulum nisi. Nullam vehicu
                    🏖☀”
                  </p>
                  <p>
                    Vestibulum nec erat ut mi sollicitudin porttitor id sit amet
                    risu.”
                  </p>
                </div>
              </div>
              <div className="u-margin-left">
                <button className="c-btn c-btn--edit" />
              </div>
            </div>
          </div>
        </div> */}
      </React.Fragment>
    );
  };

  render() {
    const { isLoading, error } = this.props;

    return (
      <Render
        isLoading={isLoading}
        error={error}
        render={this.renderAfterLoading}
      />
    );
  }
}

const mapDispatchToProps = {
  requestUserEventsDataIfNeeded: requestDataIfNeeded,
};

const mapStateToProps = ({ userEvents }) => ({
  isLoading: userEvents.isLoading,
  error: userEvents.error,
  userEvents: userEvents.data,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Screen);



// WEBPACK FOOTER //
// ./src/updates/user-updates/Screen.js